import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { QualificationForNest } from '../../shared/interfaces/qualification.interface';
import { QuotaService } from '../../shared/services/quota/quota.service';
import {
  NestedQuota,
  OrderNestedQuota,
  QuotaPayload,
  SelectedNestedQuota,
  RangeSet,
  Criteria,
  IndividualQuota,
} from '../../shared/interfaces/quota.interface';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { QuotaNestingService } from '../quota-nesting/quota-nesting.service';
import { Constants } from '../constants/quotas';
import { notifyMessage } from '../../shared/constants/notify-message';
import { CommonService } from '../../shared/services/common-service/common-service';
import { QUALIFICATION_CODES } from '../../shared/constants/qualification-code';
import * as _ from 'lodash';
import { BuyerSurveyResponse } from '../../shared/interfaces/survey.interface';
import { SURVEY_STATUS } from '../../shared/constants/survey-status';
import { NestedQuotaService } from '../services/nested-quota/nested-quota.service';
import { NestedAllocation } from '../quota-nesting/domain/nested-allocation';
@Component({
  selector: 'ps-ui-quota-grouping-modal',
  templateUrl: './quota-grouping-modal.component.html',
  styleUrls: ['./quota-grouping-modal.component.css'],
})
export class QuotaGroupingModalComponent implements OnInit {
  public allQualifications: Array<QualificationForNest> = [];
  private readonly _qualifications: Array<QualificationForNest> =
    this._modalData.qualifications;
  private readonly _locationQualification: QualificationForNest =
    this._modalData.locationQualification;
  private readonly _quotas: Array<QuotaPayload> = this._modalData.quotas;
  private readonly _advanceTargetingQualifications: Array<QualificationForNest> =
    this._modalData.advanceTargetingQualifications;
  public nestedQuotas: Array<NestedQuota> = this._modalData.nestedQuotas;
  public selectedNestedQuotas: Array<SelectedNestedQuota> = [];
  public hasMoreQuotasThanCompletes: boolean = false;
  private readonly _surveyGoal: number = this._modalData.completes;
  public _surveyDetails = this._modalData.surveyDetails;
  private _orderNestedQuotas: OrderNestedQuota[] = [];
  public enableCheckbox: boolean = false;
  public noOfSelectedNestedQuotas: number = 0;
  public showNoOfSelectedNestedQuotas: boolean = false;
  public disableCreateQuotaGroupButton: boolean = true;
  public showCreateQuotaGroupButton: boolean = true;
  private readonly _syncNestedQuotasEmmiter: EventEmitter<Array<NestedQuota>> =
    this._modalData.syncNestedQuotasEmmiter;
  public groupQuotasTitleNumber: number = 0;
  public disableApplyNesting = true;
  public disabledCheckboxesAtLiveSurvey: boolean = false;
  public showDraftSurveyWarningMessage: boolean = false;
  public showLiveSurveyWarningMessage: boolean = false;
  public SURVEY_STATUS = SURVEY_STATUS;
  constructor(
    @Inject(ModalData)
    private _modalData: ModalData,
    private _modalRef: ModalRef<
      QuotaGroupingModalComponent,
      {
        quotas: QuotaPayload[];
      }
    >,
    private readonly _quotaNestingService: QuotaNestingService,
    private _toastr: ToasterService,
    private _quotaService: QuotaService,
    private _commonService: CommonService,
    private nestedQuotaService: NestedQuotaService
  ) {}
  public ngOnInit(): void {
    this.nestedQuotas = _.clone(this.nestedQuotas);
    this._getQualifications();
    this._getVisibleQuotas();
    if (this.nestedQuotas.length) {
      this.selectedNestedQuotas = this._getCriteriaForNested(
        this.nestedQuotas[0].criteria
      );
      this.selectedNestedQuotas.forEach((q) => {
        this.allQualifications
          .filter((ql) => q.qualification_code === ql.qualification_code)
          .forEach((ql) => {
            ql.isSelected = true;
          });
      });
      this._getNestedQuotas();
      this._setQuotaGroupButtonStatus();
    }
    this._quotaTitleNumber();
    this._checkIfHasMoreQuotasThanCompletes();
    this._disabledButtonOnSurveyStatus();

    this.nestedQuotas = new NestedAllocation(
      this._surveyGoal,
      this.nestedQuotas
    ).audit();
  }

  private _disabledButtonOnSurveyStatus() {
    const value = this.nestedQuotas.find(
      (quota) =>
        quota.individual_quotas != undefined &&
        quota.individual_quotas.length > 0
    );
    if (this._surveyDetails.ps_survey_status === SURVEY_STATUS.LIVE && value) {
      this.disabledCheckboxesAtLiveSurvey = true;
      this.showDraftSurveyWarningMessage = false;
      this.showLiveSurveyWarningMessage = true;
    }
    if (this._surveyDetails.ps_survey_status === SURVEY_STATUS.DRAFT && value) {
      this.showDraftSurveyWarningMessage = true;
      this.showLiveSurveyWarningMessage = false;
    }
    if (
      this._surveyDetails.ps_survey_status === SURVEY_STATUS.DRAFT &&
      !value
    ) {
      this.showDraftSurveyWarningMessage = false;
      this.showLiveSurveyWarningMessage = false;
    }
  }

  private _getCriteriaForNested(nestedCriteria: any) {
    return nestedCriteria.filter(
      (criteria: any) =>
        ![
          QUALIFICATION_CODES.CHILD_GENDER,
          QUALIFICATION_CODES.CHILD_AGE,
        ].includes(criteria.qualification_code)
    );
  }

  private _getQualifications() {
    this.allQualifications =
      this._quotaNestingService.getAllQualificationsForNest(
        this._qualifications,
        this._advanceTargetingQualifications
      );
  }
  private _getVisibleQuotas(): void {
    for (const quota of this._quotas) {
      const quotaQualificationCodes = this._getQualificationCode(quota);
      for (const qualification of this.allQualifications) {
        if (
          quotaQualificationCodes.includes(qualification.qualification_code) &&
          !qualification.isAdvanceTargetingParent
        ) {
          qualification.isVisible = true;
          qualification.isChecked = !!qualification.hasNestedQuotas;
        }
      }
    }
  }

  private _quotaTitleNumber() {
    let val: RegExpMatchArray | null | undefined = null;
    this.nestedQuotas.forEach((qual) => {
      if (qual.individual_quotas) {
        val = qual.quota_title?.match(/(\d+)/);
        if (val) {
          this.groupQuotasTitleNumber = Number(val[0]);
        }
      }
    });
    if (val === null || val === undefined) {
      this.groupQuotasTitleNumber = 0;
    }
  }

  private _getQualificationCode(quota: QuotaPayload): Array<number> {
    const qualificationsInQuotaCriteria: number[] = [];
    quota.criteria.forEach((criteria) => {
      qualificationsInQuotaCriteria.push(criteria.qualification_code);
    });
    return qualificationsInQuotaCriteria;
  }

  public toggleSelectQualification(
    qualificationForNest: QualificationForNest,
    index: number
  ) {
    const activate: boolean = !qualificationForNest.isChecked;
    if (activate) {
      this._hasHitTheNestedQuotaLimits(index);
      qualificationForNest.isChecked = activate;
      this.disableApplyNesting = false;
    } else {
      qualificationForNest.isChecked = activate;
      qualificationForNest.hasNestedQuotas = false;
      this.disableApplyNesting = !!!this.allQualifications.some(
        (qualification) => qualification.isChecked
      );
    }
    this.showDraftSurveyWarningMessage = false;
    this._setQuotasSortingOnSelection(qualificationForNest);
    this._nestedSelectedQualifications();
    this._setQuotaGroupButtonStatus();
  }

  private _setQuotaGroupButtonStatus() {
    this.noOfSelectedNestedQuotas = 0;
    this.groupQuotasTitleNumber = 0;
    const nestQual = this.allQualifications.find(
      (nestQualification) => nestQualification.isChecked === true
    );
    if (nestQual) {
      this.disableCreateQuotaGroupButton = false;
    } else {
      this.disableCreateQuotaGroupButton = true;
      this.showCreateQuotaGroupButton = true;
      this.showNoOfSelectedNestedQuotas = false;
      this.enableCheckbox = false;
    }
  }

  private _hasHitTheNestedQuotaLimits(index: number): void {
    const activeQuotas = this.allQualifications.filter(
      (qualification) => qualification.isChecked
    );
    if (activeQuotas.length >= Constants.NESTED_QUOTA_LIMIT) {
      if (this.allQualifications[index].isChecked === false) {
        this.allQualifications[index].isChecked = null as any;
      } else {
        this.allQualifications[index].isChecked = false;
      }
      throw this._toastr.warning(
        notifyMessage.warningMessage.QUOTA.MAXIMUM_QUOTAS_TO_NEST.replace(
          ':NESTED_QUOTA_LIMIT',
          `${Constants.NESTED_QUOTA_LIMIT}`
        )
      );
    }
  }

  private _setQuotasSortingOnSelection(
    nestQualification: QualificationForNest
  ) {
    const { isChecked } = nestQualification;
    if (isChecked) {
      this._orderNestedQuotas.push({
        order: this.selectedNestedQuotas.length,
        qualificationCode: nestQualification.qualification_code,
        qualificationName: nestQualification.qualification_name,
      });
    } else {
      const index = this._orderNestedQuotas.findIndex(
        (quotaOrder) =>
          quotaOrder.qualificationCode === nestQualification.qualification_code
      );
      if (index > -1) {
        let { order } = this._orderNestedQuotas[index];
        this._orderNestedQuotas.splice(index, 1);
        this._orderNestedQuotas
          .filter(({ order: quotaOrder }) => quotaOrder > order)
          .forEach((orderAfter) => {
            orderAfter.order -= 1;
          });
      }
    }
  }

  private _nestedSelectedQualifications(): void {
    const selectedQualifications = this.allQualifications.filter(
      (qualification) => qualification.isChecked
    );
    this.selectedNestedQuotas = selectedQualifications;
    if (!selectedQualifications.length) {
      this.nestedQuotas = [];
      return;
    }
    this._sortNestedSelectedQuotas();
    this.nestedQuotas =
      this._quotaNestingService.nestQuotasForQualifications(
        this._quotas,
        selectedQualifications,
        this._surveyGoal
      ) ?? [];
    this._checkIfHasMoreQuotasThanCompletes();

    this.nestedQuotas = new NestedAllocation(
      this._surveyGoal,
      this.nestedQuotas
    ).audit();
  }
  private _sortNestedSelectedQuotas() {
    const findOrderQuota = (quota: SelectedNestedQuota): number =>
      this._orderNestedQuotas.find(
        (nestedQuotaOrder) =>
          nestedQuotaOrder.qualificationCode === quota.qualification_code
      )?.order || 0;
    this.selectedNestedQuotas.sort(
      (i, j) => findOrderQuota(i) - findOrderQuota(j)
    );
  }
  /**  private _getVisibleQuotas(): void {
    let quotaQualificationNameArray: any[] = [];

    for (const quota of this._quotas) {
      const quotaQualificationName = this._getQuotaQualificationName(quota);
      quotaQualificationNameArray.push(quotaQualificationName);
    }
    const quotasCriteriaValue = Object.values(
      quotaQualificationNameArray.reduce((previousValue, currentValue) => {
        if (!previousValue[currentValue.qualificationCode]) {
          previousValue[currentValue.qualificationCode] = {
            qualificationCode: currentValue.qualificationCode,
            data: [currentValue.QuotaCriteria],
          };
        } else {
          previousValue[currentValue.qualificationCode].data.push(
            currentValue.QuotaCriteria
          );
        }
        return previousValue;
      }, {})
    );

    for (const quota of quotasCriteriaValue) {
      const quotaQualificationCodes =
        this._getQualificationCode(quotasCriteriaValue);
      for (const qualification of this.allQualifications) {
        if (
          quotaQualificationCodes.includes(qualification.qualification_code) &&
          !qualification.isAdvanceTargetingParent
        ) {
          const result: any = quotasCriteriaValue.find(
            (response: any) =>
              response.qualificationCode === qualification.qualification_code
          );
          qualification.isVisible = true;
          qualification.showAllQualificationsValue = false;
          if (result) {
            qualification.quotasElements = result.data;
            qualification.totalQuotas =
              qualification && qualification.quotasElements
                ? qualification.quotasElements.length
                : 0;
          }
          qualification.isSelected = !!qualification.hasNestedQuotas;
        }
      }
    }
  }

  private _getQualificationCode(
    quotasCriteriaValue: any[]
  ): Array<number> {
    const qualificationsInQuotaCriteria: number[] = [];
    quotasCriteriaValue.forEach((criteria) => {
      qualificationsInQuotaCriteria.push(criteria.qualificationCode);
    });
    return qualificationsInQuotaCriteria;
  }

  private _getQuotaQualificationName(quota: QuotaPayload) {
    let criteriaObject = {
      qualificationCode: 0,
      QuotaCriteria: '',
    };
    quota.criteria.forEach((criteria) => {
      criteriaObject.qualificationCode = criteria.qualification_code;
      let title = this._quotaService.breakArrayAndJoinQuotaViewItem(
        quota.criteria
      );

      criteriaObject.QuotaCriteria = title;
    });
    return criteriaObject;
  }

  public enableSubMenu(qualification_code: number, type: string) {
    if (type === 'up') {
      this.allQualifications = this.allQualifications.map((x) => {
        return x.qualification_code === qualification_code
          ? { ...x, showAllQualificationsValue: false }
          : x;
      });
    } else {
      this.allQualifications = this.allQualifications.map((x) => {
        return x.qualification_code === qualification_code
          ? { ...x, showAllQualificationsValue: true }
          : x;
      });
    }
  }

  addRemoveFromNestingObject(qualificationForNest: any) {
    const found = this.selectedNestedQuotas.some(
      (quota: any) =>
        quota.qualification_code === qualificationForNest.qualification_code
    );

    if (!found) {
      this.selectedNestedQuotas.push(qualificationForNest);
    } else if (found) {
      this.selectedNestedQuotas = this.selectedNestedQuotas.filter(
        (quota: any) =>
          quota.qualification_code === qualificationForNest.qualification_code
      );
    }

  const selectedQualificationsToNest = this.allQualifications.filter(
    (qualification) => qualification.isSelected
  );
  this.selectedNestedQuotas = selectedQualificationsToNest;
  if (!selectedQualificationsToNest.length) {
    this.nestedQuotas = [];
    return;
  }
  this._sortSelectedNestedQuotas();
  this.nestedQuotas =
    this._quotaNestingService.nestQuotasForQualifications(
      this._quotas,
      selectedQualificationsToNest,
      this._surveyGoal
    ) ?? [];
  this._checkIfHasMoreQuotasThanCompletes();

addRemoveFromNestingObject(qualificationForNest : any){
  const found = this.groupQuotaArray.some(
    (quota: SelectedQuota) => quota.text === selectedQuota.text
  );
if (!found) {
  selectedQuota.selectedForGroup = true;
  selectedQuota.selected = false;
  this.groupQuotaArray.push(selectedQuota);
} else if (found) {
  selectedQuota.selectedForGroup = false;
  selectedQuota.selected = true;
  this.groupQuotaArray = this.groupQuotaArray.filter(
    (quota: SelectedQuota) => quota.text !== selectedQuota.text
  );
}
}
} */

  private _checkRangeSetAvailablity(
    valueCriteriaRangeSet: RangeSet[],
    elementCriteriaRangeSet: RangeSet[]
  ) {
    for (const rangeSet of valueCriteriaRangeSet) {
      let IsConditionEqual = _.some(elementCriteriaRangeSet, rangeSet);
      if (IsConditionEqual) {
        return true;
      }
    }
    return false;
  }

  private _buildIndexCondition(
    valueCriteria: Criteria,
    payloadCriteria: Criteria[]
  ) {
    let tempIndex: number | null = null;
    let IsConditionEqual: boolean = false;
    for (const [i, element] of payloadCriteria.entries()) {
      element.condition_codes?.sort();
      element.range_sets?.sort();
      valueCriteria.condition_codes?.sort();
      valueCriteria.range_sets?.sort();
      IsConditionEqual = false;
      if (
        valueCriteria.qualification_code === QUALIFICATION_CODES.AGE ||
        valueCriteria.qualification_code === QUALIFICATION_CODES.INCOME ||
        valueCriteria.qualification_code === QUALIFICATION_CODES.CHILD_AGE
      ) {
        if (
          valueCriteria.range_sets != undefined &&
          element.range_sets != undefined
        ) {
          IsConditionEqual = this._checkRangeSetAvailablity(
            valueCriteria.range_sets,
            element.range_sets
          );
        }
      } else {
        IsConditionEqual = _.isEqual(
          element.condition_codes,
          valueCriteria.condition_codes
        );
      }

      if (
        element.qualification_code === valueCriteria.qualification_code &&
        !IsConditionEqual
      ) {
        tempIndex = i;
        break;
      } else if (
        element.qualification_code === valueCriteria.qualification_code &&
        IsConditionEqual
      ) {
        tempIndex = -1;
        break;
      }
    }
    return tempIndex;
  }
  private _addPayloadCriteria(
    valueCriteria: Criteria,
    payloadCriteria: Criteria[],
    index: number
  ) {
    if (index !== null && index >= 0) {
      valueCriteria.condition_codes?.forEach((conditionCodes) => {
        if (!payloadCriteria[index].condition_codes?.includes(conditionCodes)) {
          payloadCriteria[index].condition_codes?.push(conditionCodes);
        }
      });
      valueCriteria.condition_names?.forEach((conditionNames) => {
        if (!payloadCriteria[index].condition_names?.includes(conditionNames)) {
          payloadCriteria[index].condition_names?.push(conditionNames);
        }
      });

      valueCriteria.range_sets?.forEach((range_sets) => {
        if (!payloadCriteria[index].range_sets?.includes(range_sets)) {
          payloadCriteria[index].range_sets?.push(range_sets);
        }
      });
      if (
        payloadCriteria[index].original_maximum &&
        valueCriteria.original_maximum
      ) {
        payloadCriteria[index].original_maximum = payloadCriteria[index]
          .original_maximum
          ? payloadCriteria[index].original_maximum
          : 0 + valueCriteria.original_maximum;
      }
      if (
        payloadCriteria[index].original_minimum &&
        valueCriteria.original_minimum
      ) {
        payloadCriteria[index].original_minimum = payloadCriteria[index]
          .original_minimum
          ? payloadCriteria[index].original_minimum
          : 0 + valueCriteria.original_minimum;
      }
      if (
        payloadCriteria[index].original_percentage &&
        valueCriteria.original_percentage
      ) {
        payloadCriteria[index].original_percentage = payloadCriteria[index]
          .original_percentage
          ? payloadCriteria[index].original_percentage
          : 0 + valueCriteria.original_percentage;
      }
    }
  }

  private _buildCriteriaPayloadforQuotaGroup(
    valueCriteria: Criteria,
    payloadCriteria: Criteria[]
  ) {
    if (!payloadCriteria.length) {
      payloadCriteria.push(valueCriteria);
    } else {
      const index = this._buildIndexCondition(valueCriteria, payloadCriteria);
      if (index == null) {
        payloadCriteria.push(valueCriteria);
      } else if (index !== null && index >= 0) {
        this._addPayloadCriteria(valueCriteria, payloadCriteria, index);
      }
    }
  }

  private _buildCriteriaForIndividualQuotas(
    value: Criteria,
    newCriteria: Array<Object>
  ) {
    if (
      Array.isArray(newCriteria) &&
      value.condition_codes &&
      !value.range_sets
    ) {
      newCriteria.push({
        qualification_code: value.qualification_code,
        condition_codes: value.condition_codes,
        qualification_name: value.qualification_name,
        condition_names: value.condition_names,
        group_name: value.group_name,
        original_maximum: value.original_maximum,
        original_minimum: value.original_minimum,
        original_number: value.original_number,
        original_percentage: value.original_percentage,
        original_required_count: value.original_required_count,
        db_qualification_code: value.db_qualification_code,
      });
    } else if (Array.isArray(newCriteria) && value.range_sets) {
      newCriteria.push({
        qualification_code: value.qualification_code,
        range_sets: value.range_sets,
        qualification_name: value.qualification_name,
        condition_names: value.condition_names,
        original_maximum: value.original_maximum,
        original_minimum: value.original_minimum,
        original_number: value.original_number,
        original_percentage: value.original_percentage,
        original_required_count: value.original_required_count,
      });
    }
  }

  // eslint-disable-next-line complexity
  private _buildQualificationForNewQuotaGroup(
    groupQualification: NestedQuota,
    qualification: NestedQuota
  ) {
    if (
      qualification.fielded != undefined &&
      groupQualification.fielded != undefined
    ) {
      groupQualification.fielded =
        groupQualification.fielded + qualification.fielded;
    }
    if (
      qualification.flexiblePer != undefined &&
      groupQualification.flexiblePer != undefined
    ) {
      groupQualification.flexiblePer =
        groupQualification.flexiblePer + qualification.flexiblePer;
    }
    if (
      qualification.maximum != undefined &&
      groupQualification.maximum != undefined
    ) {
      groupQualification.maximum =
        groupQualification.maximum + qualification.maximum;
    }
    if (
      qualification.minimum != undefined &&
      groupQualification.minimum != undefined
    ) {
      groupQualification.minimum =
        groupQualification.minimum + qualification.minimum;
    }
    if (
      qualification.number != undefined &&
      groupQualification.number != undefined
    ) {
      groupQualification.number =
        groupQualification.number + qualification.number;
    }
    if (
      qualification.required_count != undefined &&
      groupQualification.required_count != undefined
    ) {
      groupQualification.required_count =
        groupQualification.required_count + qualification.required_count;
    }
    if (
      qualification.percentage != undefined &&
      groupQualification.percentage != undefined
    ) {
      groupQualification.percentage =
        groupQualification.percentage + qualification.percentage;
    }
    groupQualification.buyer_quota_id = this._commonService.getRandomString();
    groupQualification.isQuotaGrouped = true;
    groupQualification.isChecked = false;
  }

  private _groupNestedQuota() {
    let individualQuotasCriteria: {
      db_qualification_code: number;
      qualification_code: number;
      condition_codes?: string[];
      range_sets?: RangeSet[];
      group_name?: string;
      qualification_name: string;
      condition_names: string[];
      original_maximum: number;
      original_minimum: number;
      original_number: number;
      original_percentage: number;
      original_required_count: number;
    }[] = [];
    let groupQualification: NestedQuota = {
      required_count: 0,
      criteria: [],
      fielded: 0,
      flexiblePer: 0,
      maximum: 0,
      minimum: 0,
      number: 0,
      percentage: 0,
    };
    let criteria: Criteria[] = [];
    let individualQuotaGroups: IndividualQuota[] = [];
    this.nestedQuotas.forEach((qualification) => {
      if (qualification.isChecked) {
        qualification.criteria.forEach((value) => {
          const valueX = JSON.parse(JSON.stringify(value));
          this._buildCriteriaForIndividualQuotas(
            value,
            individualQuotasCriteria
          );
          this._buildCriteriaPayloadforQuotaGroup(valueX, criteria);
        });

        this._buildQualificationForNewQuotaGroup(
          groupQualification,
          qualification
        );
        const quotaGroup = {
          combinedKey: qualification.combinedKey,
          allocation: {
            quantity: qualification.number || qualification.required_count,
            percentage: qualification.percentage || 0,
            min: qualification.minimum || 0,
            max: qualification.maximum || 0,
            fielded: qualification.fielded || 0,
          },
          criteria: individualQuotasCriteria,
          required_count: qualification.required_count,
        };
        individualQuotaGroups.push(quotaGroup);
        groupQualification.criteria = criteria;
        groupQualification.individual_quotas = individualQuotaGroups;
        individualQuotasCriteria = [];
      }
    });
    groupQualification.quota_title =
      'Quota Group ' + String(++this.groupQuotasTitleNumber);

    this.nestedQuotas = this.nestedQuotas.filter(
      (item) => !item.isChecked || item.isQuotaGrouped
    );
    if (groupQualification.buyer_quota_id) {
      this.nestedQuotas.push(groupQualification);
    }
    this.showDraftSurveyWarningMessage = true;
  }

  public deleteQuotaGroup(index: number) {
    let criteriax: Criteria[] = [];
    let eachCriteria: Criteria = {
      qualification_code: 0,
    };
    let groupQualification: NestedQuota = {
      required_count: 0,
      criteria: [],
      combinedKey: [],
      fielded: 0,
      flexiblePer: 0,
      maximum: 0,
      minimum: 0,
      number: 0,
      percentage: 0,
    };
    this.nestedQuotas[index].individual_quotas?.forEach((quota) => {
      groupQualification.buyer_quota_id = this._commonService.getRandomString();
      quota.criteria.forEach((val) => {
        eachCriteria.qualification_code = val.qualification_code;
        if (val.qualification_name) {
          eachCriteria.qualification_name = val.qualification_name;
        }
        if (val.group_name) {
          eachCriteria.group_name = val.group_name;
        }
        eachCriteria.db_qualification_code = val.db_qualification_code;
        if (val.range_sets) {
          eachCriteria.range_sets = val.range_sets;
        } else {
          if (val.condition_names) {
            eachCriteria.condition_names = val.condition_names;
          }

          eachCriteria.condition_codes = val.condition_codes;
        }
        if (val.original_percentage) {
          eachCriteria.original_percentage = val.original_percentage;
        }
        eachCriteria.original_maximum = val.original_maximum;
        eachCriteria.original_minimum = val.original_minimum;
        eachCriteria.original_number = val.original_number;
        eachCriteria.original_percentage = val.original_percentage;
        eachCriteria.original_required_count = val.original_required_count;
        criteriax.push(eachCriteria);
        eachCriteria = { qualification_code: 0 };
      });

      groupQualification.combinedKey = quota.combinedKey;
      groupQualification.fielded = quota.allocation.fielded;
      groupQualification.maximum = quota.allocation.max;
      groupQualification.minimum = quota.allocation.min;
      groupQualification.number = quota.allocation.quantity;
      groupQualification.percentage = quota.allocation.percentage;
      groupQualification.quota_category = 'autoNested';
      groupQualification.criteria = criteriax;
      this.nestedQuotas.push(groupQualification);
      criteriax = [];
      groupQualification = { required_count: 0, criteria: [] };
    });
    this.nestedQuotas.splice(index, 1);
    this._quotaTitleNumber();
    this.disableApplyNesting = false;
    this._disabledButtonOnSurveyStatus();
  }
  showOrHideCheckboxes() {
    if (this.noOfSelectedNestedQuotas == 1) {
      this._toastr.warning(
        'Error: Please select more than one quota. A minimum of 2 options is required'
      );
    } else {
      this.enableCheckbox = !this.enableCheckbox;
      this.showNoOfSelectedNestedQuotas = !this.showNoOfSelectedNestedQuotas;
      this.showCreateQuotaGroupButton = !this.showCreateQuotaGroupButton;
    }
    if (this.showCreateQuotaGroupButton && this.noOfSelectedNestedQuotas > 1) {
      this.noOfSelectedNestedQuotas = 0;
      this._groupNestedQuota();
      this.disableApplyNesting = false;
    }
  }
  toggleQuotaNestingGroup(quota: NestedQuota, event: Event) {
    const e = <HTMLInputElement>event.currentTarget;
    this.nestedQuotas.forEach((qualification) => {
      if (qualification.buyer_quota_id === quota.buyer_quota_id) {
        qualification.isChecked = e.checked;
      }
    });
    e.checked
      ? this.noOfSelectedNestedQuotas++
      : this.noOfSelectedNestedQuotas--;
  }

  public clearNesting(): void {
    this.nestedQuotas = [];
    this.selectedNestedQuotas = [];
    this.disableCreateQuotaGroupButton = true;
    this.showCreateQuotaGroupButton = true;
    this.noOfSelectedNestedQuotas = 0;
    this.showNoOfSelectedNestedQuotas = false;
    this.enableCheckbox = false;
    this.showDraftSurveyWarningMessage = false;
    this.allQualifications.forEach((qualification) => {
      qualification.isChecked = false;
    });
    this._sendNestedQuotasToParent();
    this.disableApplyNesting = true;
  }

  public applyNesting(): void {
    let array: string[] = [];
    let showError: boolean = false;
    this.nestedQuotas.forEach((quota) => {
      if (quota.individual_quotas?.length && quota.quota_title) {
        if (array.includes(quota.quota_title)) {
          showError = true;
          this._toastr.warning('Quota titles should be unique.');
        } else {
          array.push(quota.quota_title);
        }
      }
    });
    if (!showError) {
      this.manageNestedQuotas();
      this._sendNestedQuotasToParent();
      this._modalRef.close();
    }
  }

  private _sendNestedQuotasToParent(): void {
    this._syncNestedQuotasEmmiter.emit(this.nestedQuotas);
  }

  private _getNestedQuotas() {
    let combinedKey: string[] = [];
    this.nestedQuotas.forEach((nestedQuota) => {
      if (
        nestedQuota.individual_quotas &&
        nestedQuota.individual_quotas.length
      ) {
        nestedQuota.individual_quotas.forEach((quota) => {
          quota.combinedKey = this._getCombinedKey(quota);
          combinedKey = [];
        });
        nestedQuota.isQuotaGrouped = true;
        nestedQuota.isChecked = false;
      } else {
        nestedQuota.isChecked = false;
        nestedQuota.combinedKey = this._getCombinedKey(nestedQuota);
        combinedKey = [];
      }
    });
  }

  private _getCombinedKey(quota: any) {
    let qualification;
    const combinedKey: string[] = [];
    let i = -1;
    quota.criteria.forEach((item: any) => {
      if (
        item.qualification_code == QUALIFICATION_CODES.CHILD_GENDER ||
        item.qualification_code == QUALIFICATION_CODES.CHILD_AGE
      ) {
        qualification = this.allQualifications.find(
          (qual) => qual.db_qualification_code === QUALIFICATION_CODES.CHILDREN
        );
      } else {
        qualification = this.allQualifications.find(
          (qual) => qual.qualification_code === item.qualification_code
        );
      }
      let text = this._quotaNestingService.getQuotaName(
        qualification ? qualification : ({} as any),
        item
      );
      if (text) {
        if (item.qualification_code === QUALIFICATION_CODES.CHILD_AGE) {
          combinedKey[i] = combinedKey[i].concat(',', text);
        } else {
          i++;
          combinedKey[i] = text;
        }
      }
    });
    return combinedKey;
  }

  public manageNestedQuotas() {
    this.nestedQuotas.forEach((nestedQuota) => {
      nestedQuota.initialQuotaTitle = '';
    });
  }

  public updateQuotanestingEdit(nestedQuota: NestedQuota) {
    nestedQuota.initialQuotaTitle = nestedQuota.quota_title;
  }

  public verifyQuotaTitle(nestedQuota: NestedQuota) {
    if (nestedQuota.quota_title === '') {
      nestedQuota.quota_title = nestedQuota.initialQuotaTitle;
    }
  }

  public updateQuotaPercentage(nestedQuota: NestedQuota) {
    this.nestedQuotaService.updateQuotaPercentage(
      nestedQuota,
      this.nestedQuotas,
      this._surveyGoal
    );
    this.nestedQuotaService.updateIndividualQuotas(
      nestedQuota,
      this._surveyGoal
    );
  }

  public updateQuotaAllocation(nestedQuota: NestedQuota) {
    this.nestedQuotaService.updateQuotaAllocation(
      nestedQuota,
      this.nestedQuotas,
      this._surveyGoal
    );
    this.nestedQuotaService.updateIndividualQuotas(
      nestedQuota,
      this._surveyGoal
    );
  }

  public setInitialAllocation(nestedQuota: NestedQuota) {
    if (nestedQuota.required_count && nestedQuota.initialQuotaAllocation) {
      nestedQuota.required_count = nestedQuota.initialQuotaAllocation;
    }
  }

  public disableApplyNestingButton() {
    this.disableApplyNesting = false;
  }
  private _checkIfHasMoreQuotasThanCompletes(): void {
    this.hasMoreQuotasThanCompletes =
      this.nestedQuotas.length > this._surveyGoal;
  }
}
interface ModalData {
  syncNestedQuotasEmmiter: EventEmitter<NestedQuota[]>;
  advanceTargetingQualifications: [];
  completes: number;
  isEditMode: boolean;
  nestedQuotas: [];
  qualifications: [];
  locationQualification: QualificationForNest;
  quotas: [];
  surveyDetails: BuyerSurveyResponse;
}
